const openedPaymentPage = {
  fawry: {
    title: 'Pembayaran Anda telah dibuat!',
    importantMessage: {
      title: 'Penting untuk diketahui',
      description: 'Untuk menyelesaikan pembayaran dan menghindari pembatalan, silakan gunakan kode referensi untuk membayar melalui saluran Fawry, outlet, atau Aplikasi Fawry dalam waktu yang ditentukan',
    },
    orderDetail: {
      expirationDate: 'Tanggal kedaluwarsa pembayaran:',
      totalAmount: 'Jumlah total',
    },
    referenceNumber: {
      title: 'Nomor referensi',
      copy: 'Salin',
      copied: 'Tersalin!',
    },
  },
  customer: {
    form: {
      fieldCustomerBirthdate: {
        label: 'Tanggal Lahir',
        validationMessage: {
          empty: 'Silakan masukkan tanggal lahir Anda',
          invalid: 'Tanggal lahir tidak valid',
          serverError: 'Kesalahan server. Silakan coba lagi nanti.',
        },
      },
    },
  },
  cryptocurrency: {
    disclaimer1: 'Pembayaran dengan kripto diproses secara eksklusif oleh penyedia eksternal yang berwenang, bukan oleh EBANX. Detail penyedia, termasuk lisensi dan status regulasi masing-masing, tercantum dalam ',
    termsAndConditions: 'Syarat dan Ketentuan',
    disclaimer2: ' yang berlaku.',
    merchantInfo: {
      returnButton: 'Anda dapat membatalkan pembayaran ini dan kembali ke halaman checkout untuk memilih metode pembayaran lain.',
      backTo: 'Batalkan dan kembali',
    },
  },
};

module.exports = openedPaymentPage;
